import { Collapse } from 'antd';
import './custom-accordion.css';

import InputDescription from '../quiz-input-show-description/quiz-input-show-description';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const CustomAccordion = ({ name, description, questionTooltip }) => {
  //TO RENDER DESCRIPTION OF INPUTS
  function ShowDescription(description) {
    return <InputDescription description={description} questionTooltip={questionTooltip} />;
  }
  return (
    <Collapse
      expandIconPosition="end"
      className="collapse-container"
      expandIcon={({ isActive }) =>
        isActive ? (
          <UpOutlined style={{ color: 'white' }} />
        ) : (
          <DownOutlined style={{ color: '#003E69' }} />
        )
      }
    >
      <Panel header={name} key={''}>
        {description && ShowDescription(description)}
      </Panel>
    </Collapse>
  );
};

export default CustomAccordion;
